import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as tutorialActions from '../tutorial.actions'

import * as tutorialSelectors from '../tutorial.selectors'

import SettingsMenuButton from '../../Mars/Settings/SettingsMenuButton'

const AcademyScreen = ({
  goTo,
  clickAcademySwitch,
  academySwitch,
  confidentialNumber,
  showSettings,
}) => (
  <main className="main" role="main">
    {showSettings && <SettingsMenuButton />}
    <div className="container background--mina__canvas">
      <div className="content">
        <div className="tutorial--welcome">
          <h1 className="h1">
            <FormattedMessage id="tutorial.welcome.title1" />
            <span className="name">
              <FormattedMessage id="tutorial.welcome.title2" />
            </span>
          </h1>
          <p>
            <FormattedMessage id="tutorial.welcome.body.p1" />
          </p>
          <p>
            <FormattedMessage id="tutorial.welcome.body.p2" />
            <b>
              <FormattedMessage id="tutorial.welcome.body.p2_End" />
            </b>
          </p>
          <p>
            <FormattedMessage id="tutorial.welcome.code" />
          </p>
          <div className="tutorial--code">
            <div
              className={`tutorial--switch ${academySwitch && 'active'}`}
              onMouseDown={() => clickAcademySwitch()}
              onTouchStart={() => clickAcademySwitch()}
            >
              <FormattedMessage id="tutorial.welcome.confidential" />
            </div>
            <div className="tutorial--code__item">#{confidentialNumber}</div>
          </div>

          <div
            className={`btn--orange ${academySwitch ? '' : 'visibility--hidden'}`}
            onClick={() => goTo({ turn: 1, phase: 2 })}
          >
            <span className="icon-rocket"></span>
            <span>
              <FormattedMessage id="tutorial.common_texts.start" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </main>
)

AcademyScreen.propTypes = {
  goTo: PropTypes.func,
  clickAcademySwitch: PropTypes.func,
  academySwitch: PropTypes.bool,
  confidentialNumber: PropTypes.number,
  showSettings: PropTypes.bool,
}

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(tutorialActions.goTo, dispatch),
  clickAcademySwitch: bindActionCreators(tutorialActions.clickAcademySwitch, dispatch),
})

const mapStateToProps = (state) => ({
  academySwitch: tutorialSelectors.getAcademySwitch(state),
  confidentialNumber: tutorialSelectors.getConfidentialNumber(state),
  showSettings: !tutorialSelectors.isUrlMode(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AcademyScreen))
